import { render, staticRenderFns } from "./xwsj_wz.vue?vue&type=template&id=0f26e3c9&scoped=true&"
import script from "./xwsj_wz.vue?vue&type=script&lang=js&"
export * from "./xwsj_wz.vue?vue&type=script&lang=js&"
import style0 from "./xwsj_wz.vue?vue&type=style&index=0&id=0f26e3c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f26e3c9",
  null
  
)

export default component.exports